import Api from "@/services/Index";

const getAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/course/agreements", config);
};
const getStudentCourses = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("course/agreement/"+id);
};
const approvedApplication = async (data,id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put(`/approval/step/update/status/${id}`,data);
};
const del= async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.delete(`/course/agreement/${id}`);
};
const exportExcel = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    config.responseType = 'arraybuffer'
    return Api.get('/course/agreement/excel-export', config);
}
const exportCourseCountExcel = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    config.responseType = 'arraybuffer'
    return Api.get('/course/agreement/course-count-report', config);
}
const setWaitingWdcApprove = async (courseAgreementId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get(`/course/agreement/set-waiting-wdc-approve/${courseAgreementId}`);
};

export default {
    getAll,
    getStudentCourses,
    approvedApplication,
    del,
    exportExcel,
    exportCourseCountExcel,
    setWaitingWdcApprove
};
